import * as SYFActions from '../actionTypes/SYFActionTypes';

export const getQuickScreenEligibilityCheck = () => ({
    type: SYFActions.GET_QUICKSCREEN_ELIGIBLITY_CHECK,
});

export const updateQuickScreenWidgetDetails = (payload) => ({
    type: SYFActions.UPDATE_QUICKSCREEN_WIDGET_DETAILS,
    payload,
});

export const triggerQuickScreenAnalytics = (payload) => ({
    type: SYFActions.QUICKSCREEN_ANALYTICS_EVENT,
    payload,
});

export const getQuickScreenUserRewardsId = (payload) => ({
    type: SYFActions.WEB_GET_REWARD_PROFILE_REQUEST,
    payload,
});

export const openQuickScreenRequest = (payload) => ({
    type: SYFActions.WEB_OPEN_QUICK_SCREEN_REQUEST,
    payload,
});
export const loadSYFQSScript = (payload) => ({
    type: SYFActions.LOAD_SYF_QUICKSCREEN_SCRIPT,
    payload,
});
export const resetQuickScreenEligiblity = () => ({
    type: SYFActions.RESET_QUICKSCREEN_ELIGIBLITY,
});
export const getPLCCDetailsHtml = (href) => ({
    type: 'GET_PLCC_DETAILS_HTML',
    href,
});
